// extracted by mini-css-extract-plugin
export default {"classroom":"Classroom_classroom__dlIHX","classroomBg":"Classroom_classroomBg__aCvrp","classroomText":"Classroom_classroomText__ewgmc"};